import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { ProjectTeamEditInterface } from "../../../middleware/interfaces/project/project-team-edit-interface";

export const ProjectTeamEdit = {
  Edit: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const ProjectTeamEditData: ProjectTeamEditInterface = state.data;
      const url = "./php/project/project-team-edit-proxy.php";
      await axios
        .post(url, ProjectTeamEditData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
